import { render, staticRenderFns } from "./ExchangePopup.vue?vue&type=template&id=c11d2962&scoped=true&"
import script from "./ExchangePopup.vue?vue&type=script&lang=ts&"
export * from "./ExchangePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangePopup.vue?vue&type=style&index=0&id=c11d2962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11d2962",
  null
  
)

export default component.exports